import React from 'react';
import { H4, Image, P } from '../../../AbstractElements';
import { MainCardPara1, MainCardPara2 } from '../../../Data/KnowledegesBase';
import { Card, CardBody, Col } from 'reactstrap';
import { WhychooseKnowledge } from '../../../Constant';
import img from '../../../assets/images/knowledgebase/1.jpg';

const MainCard = () => {
  return (
    <Col xl='9 xl-60 box-col-60'>
      <div className='blog-single'>
        <div className='blog-box'>
          <Card>
            <Image className='img-fluid w-100' src={img} alt='blog-main' />
          </Card>
          <Card>
            <CardBody>
              <div className='blog-details'>
                <H4 className='mt-0'>{WhychooseKnowledge}</H4>
                <div className='single-blog-content-top'>
                  <P>{MainCardPara1}</P>
                  <P>{MainCardPara2}</P>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </Col>
  );
};
export default MainCard;
